import { render, staticRenderFns } from "./BindAccount.vue?vue&type=template&id=434be06c&scoped=true&"
import script from "./BindAccount.vue?vue&type=script&lang=js&"
export * from "./BindAccount.vue?vue&type=script&lang=js&"
import style0 from "./BindAccount.vue?vue&type=style&index=0&id=434be06c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434be06c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('434be06c')) {
      api.createRecord('434be06c', component.options)
    } else {
      api.reload('434be06c', component.options)
    }
    module.hot.accept("./BindAccount.vue?vue&type=template&id=434be06c&scoped=true&", function () {
      api.rerender('434be06c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/queuePopup/BindAccount.vue"
export default component.exports